import { render, staticRenderFns } from "./GMDefineArea.vue?vue&type=template&id=3f6ac0a1&scoped=true&"
import script from "./GMDefineArea.vue?vue&type=script&lang=js&"
export * from "./GMDefineArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ac0a1",
  null
  
)

export default component.exports